import * as React from 'react';
import { useDispatch } from 'react-redux';
import { getFIOSuggestRequest } from '../../../actions/fio';
import { EPartsLower, EGender, TGetFIOSuggest } from '../../../types/fio';

export function useGetFIOSuggest() {
  const dispatch = useDispatch();

  return (React.useCallback(
    (query: string, currentPartFIO: EPartsLower, gender: EGender) => {
      return dispatch(getFIOSuggestRequest(query, currentPartFIO, gender));
    },
    [dispatch],
  ) as unknown) as TGetFIOSuggest;
}
